import { UnitParams } from '~/types/Unit';
import { HostInfo } from '~/utils/host';
import { GetCompanyUnitsListingUseCase } from './company-unit-listing/getCompanyListingUseCase';
import { MagicUseCase } from './magicUseCase';

export class InitializeAppUseCase extends MagicUseCase {
  protected async runLogic(hostInfo: HostInfo) {
    this.getState().user.domain = hostInfo.hostname;
    const unitParams: UnitParams = {
      page: 1,
      pageSize: 6,
    };
    await new GetCompanyUnitsListingUseCase(this.eventEmitter).execute(unitParams);
    const companyInfo = this.getState().user.companyInfo;
    if (!import.meta.env.DEV && companyInfo?.customDomain) {
      if (hostInfo.hostname && hostInfo.hostname !== companyInfo.customDomain) {
        let url = `https://${companyInfo.customDomain}`;
        if (hostInfo.path) {
          url += hostInfo.path;
        }
        return this.navigate(url);
      }
    }
  }
}
